import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { createMixin } from '@vfuk/core-mixins'

import type { Animation } from './animations.types'

const slideFromTop: Animation = {
  animation: createMixin(
    (): FlattenSimpleInterpolation => css`
      @keyframes slideFromTop {
        0% {
          transform: translateY(-100%);
        }
        100% {
          transform: translateY(0);
        }
      }
    `,
  ) as Animation['animation'],
  config: {
    duration: 150,
  },
}

export default slideFromTop
